<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card v-if="icms" :loading="salvando">
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} ICMS</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="ml-auto" type="submit" text :disabled="!validForm" @click="salvar(icms)">
          Salvar
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form ref="formDialog" v-model="validForm" @submit.prevent>
          <v-container fluid>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="icms.descricao"
                  label="Descrição"
                  required
                  :rules="[obrigatorio]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="icms.observacao"
                  label="Observação"
                  required
                  :rules="[obrigatorio]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1">
                <v-autocomplete
                  v-model="icms.uf.id"
                  :items="itens.uf"
                  :rules="[obrigatorio]"
                  label="UF"
                />
              </v-col>
              <v-col>
                <v-autocomplete
                  v-model="icms.ncm.id"
                  :items="itens.ncm"
                  :rules="[obrigatorio]"
                  label="NCM"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="icms.lei.id"
                  :items="itens.lei"
                  :rules="[obrigatorio]"
                  label="Lei"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-alert v-if="showMessageError" dense outlined type="error">
                  {{ dataError }}
                </v-alert>
              </v-col>
            </v-row>

            <v-card-title class="pa-0">Valores SAÍDA</v-card-title>

            <v-row>
              <v-col cols="5">
                <v-autocomplete
                  v-model="icms.cst.id"
                  :items="itens.cst"
                  :rules="[obrigatorio]"
                  label="CST"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="icms.icmsOriginal"
                  label="ICMS Original"
                  required
                  type="number"
                  :rules="[obrigatorio]"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="icms.icmsSaida"
                  label="ICMS Saída"
                  required
                  type="number"
                  :rules="[obrigatorio]"
                />
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="icms.mva"
                  label="MVA"
                  required
                  type="number"
                  :rules="[obrigatorio]"
                />
              </v-col>
            </v-row>

            <v-card-title v-if="operacao === 'editar'" class="pa-0">
              Valores ENTRADA
              <v-spacer />
              <v-btn color="primary" dark class="mb-2" @click="abrirDialogAdicionar">
                Adicionar
              </v-btn>
              <v-dialog v-model="dialogAdicionar" max-width="500px">
                <v-card>
                  <v-card-title>
                    <span class="headline">
                      {{
                        operacaoIcmsValorEntrada === 'editar'
                          ? 'Editar valor entrada'
                          : 'Adicionar valores entrada'
                      }}
                    </span>
                  </v-card-title>

                  <v-card-text>
                    <v-form ref="formDialogAdicionar" v-model="validFormAdicionar" @submit.prevent>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-autocomplete
                              v-model="editedItem.tipoFornecedor"
                              :items="itensTiposFornecedores"
                              :rules="[obrigatorio]"
                              :disabled="operacaoIcmsValorEntrada === 'editar'"
                              label="Tipo Fornecedor *"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-autocomplete
                              v-model="editedItem.ufOrigem.id"
                              :items="itensUF"
                              :disabled="!permiteAlterarExcecoes"
                              label="UF origem"
                              clearable
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-autocomplete
                              v-model="editedItem.ufDestino.id"
                              :items="itensUF"
                              :disabled="!permiteAlterarExcecoes"
                              label="UF destino"
                              clearable
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.codigoNcm"
                              :disabled="!permiteAlterarExcecoes"
                              label="Código NCM"
                              type="number"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <CampoDeCnpj
                              v-model="editedItem.cnpj"
                              :disabled="!permiteAlterarExcecoes"
                              label="CNPJ"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.escritaFiscalCst"
                              label="EF CST"
                              type="number"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.escritaFiscalPercentualIcms"
                              label="EF % ICMS"
                              type="number"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.escritaFiscalReducao"
                              label="EF Redução"
                              type="number"
                            />
                          </v-col>

                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.notaFiscalCst"
                              label="NF CST"
                              type="number"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.notaFiscalPercentualIcms"
                              label="NF % ICMS"
                              type="number"
                            />
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="editedItem.notaFiscalReducao"
                              label="NF Redução"
                              type="number"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="dialogAdicionar = false">
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="success"
                      :disabled="!validFormAdicionar"
                      text
                      :loading="adicionando"
                      @click="adicionarNovoValorEntrada()"
                    >
                      Salvar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-title>

            <v-data-table
              v-if="operacao === 'editar'"
              :items="valoresEntradaIcms"
              :headers="headers"
              hide-default-footer
              :items-per-page="1000"
              class="elevation-1"
            >
              <template #[`item.acoes`]="{ item }">
                <div class="d-flex flex-nowrap justify-center">
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-icon class="mr-2" v-on="on" @click="abrirDialogAlterar(item)">
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-tooltip v-if="item.tipoFornecedor !== 'Padrão'" top>
                    <template #activator="{ on }">
                      <v-icon v-on="on" @click="abrirDialogRemover(item)"> mdi-delete </v-icon>
                    </template>
                    <span>Excluir</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>

            <v-dialog v-model="dialogExcluir" max-width="500px">
              <v-card>
                <v-card-title class="headline">Excluir</v-card-title>
                <v-card-text> Tem certeza que deseja remover esse valor entrada? </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogExcluir = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="removerIcmsValorEntrada">
                    Confirmar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />
  </v-dialog>
</template>

<script>
import ICMS from '@/models/icms'
import ICMSService from '@/services/icms/icms'
import UFService from '@/services/uf/uf'
import SnackBar from '@/models/components/snackbar'
import SnackbarMessage from '@/components/SnackbarMessage'
import { obrigatorio } from '@/shareds/regrasForm'
import { formataCpfCnpj } from '@/shareds/formatacoes'
import CampoDeCnpj from '@/components/ui/CampoDeCnpj.vue'

export default {
  components: { SnackbarMessage, CampoDeCnpj },
  props: ['showDialog', 'icmsParam', 'operacao', 'itens'],

  data: () => ({
    dialog: false,
    dialogAdicionar: false,
    dialogExcluir: false,
    icms: new ICMS(),
    obrigatorio: obrigatorio,
    snackbar: new SnackBar(),
    salvando: false,
    adicionando: false,
    validForm: false,
    validFormAdicionar: false,
    dataError: '',
    showMessageError: false,
    headers: [
      { text: 'Tipo Fornecedor', value: 'tipoFornecedor', sortable: false },
      { text: 'UF origem', value: 'ufOrigem.sigla', sortable: false },
      { text: 'UF destino', value: 'ufDestino.sigla', sortable: false },
      { text: 'NCM', value: 'codigoNcm', sortable: false },
      { text: 'CNPJ', value: 'cnpj', sortable: false },
      { text: 'EF CST', value: 'escritaFiscalCst', sortable: false },
      { text: 'EF % ICMS', value: 'escritaFiscalPercentualIcms', sortable: false },
      { text: 'EF Redução', value: 'escritaFiscalReducao', sortable: false },
      { text: 'NF CST', value: 'notaFiscalCst', sortable: false },
      { text: 'NF % ICMS', value: 'notaFiscalPercentualIcms', sortable: false },
      { text: 'NF Redução', value: 'notaFiscalReducao', sortable: false },
      { text: '', value: 'acoes', sortable: false }
    ],
    valoresEntradaIcms: [],
    itensUF: [],
    itensTiposFornecedores: [
      { text: 'Comércio', value: 'COMERCIO' },
      { text: 'Comércio Carne Fora de SC Art. 12-B', value: 'COMERCIO_CARNE_FORA_DE_SC_ART_12B' },
      { text: 'Distribuidora', value: 'DISTRIBUIDORA' },
      {
        text: 'Distribuidora Carne Fora de SC Art. 12-B',
        value: 'DISTRIBUIDORA_CARNE_FOR_DE_SC_ART_12B'
      },
      { text: 'Fábrica', value: 'FABRICA' },
      { text: 'Fábrica 10.49', value: 'FABRICA_10_49' },
      { text: 'Fábrica do Simples', value: 'FABRICA_DO_SIMPLES' },
      { text: 'Produtor Rural', value: 'PRODUTOR_RURAL' },
      { text: 'Simples', value: 'SIMPLES' }
    ],
    editedItem: {
      ufOrigem: { id: null },
      ufDestino: { id: null }
    },
    editedIndex: -1,
    indiceIcmsValorEntradaExclusao: 0,
    operacaoIcmsValorEntrada: 'adicionar'
  }),

  computed: {
    permiteAlterarExcecoes() {
      if (this.editedItem.tipoFornecedor === null || this.editedItem.tipoFornecedor === undefined) {
        return true
      }

      return this.editedItem.tipoFornecedor.value !== 'PADRAO'
    }
  },

  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    icmsParam() {
      return this.icmsParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },

  methods: {
    initialize() {
      this.icms = new ICMS()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()
      if (this.$refs.formDialogAdicionar) this.$refs.formDialogAdicionar.resetValidation()

      this.icms = this.icmsParam
      this.operacao === 'editar' && this.buscarValoresEntradaIcms(this.icms.id)
      this.buscarUFs()
    },

    async buscarValoresEntradaIcms(icmsId) {
      const response = await ICMSService.buscarValoresEntradaIcms(icmsId)
      this.valoresEntradaIcms = response.map((item) => ({
        ...item,
        cnpj: item.cnpj ? formataCpfCnpj(item.cnpj) : null
      }))
    },

    async buscarUFs() {
      const response = await UFService.getAll()
      this.itensUF = response.map((item) => ({ text: item.sigla, value: item.id }))
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item
        }

        const icmsSalva =
          this.operacao === 'adicionar'
            ? await ICMSService.create({ ...data })
            : await ICMSService.update(data.id, data)

        this.$emit('confirmado', icmsSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    },

    abrirDialogAdicionar() {
      if (this.$refs.formDialogAdicionar) this.$refs.formDialogAdicionar.resetValidation()
      this.dialogAdicionar = true
      this.operacaoIcmsValorEntrada = 'adicionar'
      this.editedItem = {
        ufOrigem: { id: null },
        ufDestino: { id: null }
      }
    },

    abrirDialogAlterar(item) {
      if (this.$refs.formDialogAdicionar) this.$refs.formDialogAdicionar.resetValidation()
      this.dialogAdicionar = true
      this.operacaoIcmsValorEntrada = 'editar'
      this.editedIndex = this.valoresEntradaIcms.indexOf(item)

      let ufOrigem = item.ufOrigem ? item.ufOrigem : { id: null }
      let ufDestino = item.ufDestino ? item.ufDestino : { id: null }

      this.editedItem = {
        ...item,
        tipoFornecedor: this.itensTiposFornecedores.find(
          (tipoFornecedor) => tipoFornecedor.text === item.tipoFornecedor
        ),
        ufOrigem,
        ufDestino
      }
    },

    abrirDialogRemover(item) {
      this.dialogExcluir = true
      this.indiceIcmsValorEntradaExclusao = this.valoresEntradaIcms.indexOf(item)
    },

    async removerIcmsValorEntrada() {
      const icmsValorEntradaDelete = this.valoresEntradaIcms[this.indiceIcmsValorEntradaExclusao]

      try {
        await ICMSService.removerValorEntradaIcms(icmsValorEntradaDelete.id)
        this.snackbar.snackTextParam = 'Valor entrada removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true

        this.valoresEntradaIcms.splice(this.indiceIcmsValorEntradaExclusao, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined
            ? error.message
            : error.response.data.message
            ? error.response.data.message
            : 'Ocorreu um erro durante o processo.'
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.dialogExcluir = false
      }
    },

    async adicionarNovoValorEntrada() {
      this.adicionando = true

      const data = {
        ...this.editedItem,
        tipoFornecedor: this.editedItem.tipoFornecedor.value
          ? this.editedItem.tipoFornecedor.value
          : this.editedItem.tipoFornecedor,
        cnpj: this.editedItem.cnpj
          ? this.editedItem.cnpj.replaceAll('.', '').replaceAll('/', '').replaceAll('-', '')
          : undefined,
        codigoNcm: this.editedItem.codigoNcm || undefined
      }

      try {
        const valorEntradaIcms =
          this.operacaoIcmsValorEntrada === 'adicionar'
            ? await ICMSService.criarValoresEntradaIcms(this.icms.id, data)
            : await ICMSService.atualizarValoresEntradaIcms(this.editedItem.id, data)

        this.snackbar.snackTextParam =
          this.operacaoIcmsValorEntrada === 'adicionar'
            ? 'Novo valor entrada criado para o ICMS.'
            : 'Valor entrada atualizado.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true

        valorEntradaIcms.cnpj = valorEntradaIcms.cnpj ? formataCpfCnpj(valorEntradaIcms.cnpj) : null

        this.operacaoIcmsValorEntrada === 'adicionar'
          ? this.valoresEntradaIcms.push(valorEntradaIcms)
          : Object.assign(this.valoresEntradaIcms[this.editedIndex], valorEntradaIcms)

        this.dialogAdicionar = false
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined
            ? error.message
            : error.response.data.message
            ? error.response.data.message
            : 'Ocorreu um erro durante o processo.'
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      } finally {
        this.adicionando = false
      }
    }
  }
}
</script>
